import {
  ColorfulActionButtonPropsT,
  SortOptionT,
  TabItemsPropsT,
  TableSearchProcedurePropsT,
  TableTopPanelPropsT,
  TitlePropsT,
} from "@interfaces/common";

import { Link, useLocation } from "react-router-dom";
import React from "react";
import Select, { StylesConfig } from "react-select";

import { EmbedPDF } from "@simplepdf/react-embed-pdf";
import { EyeSVG } from "@components/svgs/eye";
import { WarnSVG } from "@components/svgs";
import { NotePencilIcon } from "@phosphor-icons/react";
import { WrapperSVG } from "@components/WrapperSVG/WrapperSVG";
import styles from "@scss/common/common.module.scss";
import clsx from "clsx";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import style from "@scss/components/header.module.scss";

export const TableTopPanel = (props: TableTopPanelPropsT) => {
  const {
    text,
    options,
    onSelectOption,
    onSearch,
    hideSearchPanel,
    hideSelectPanel,
    withoutPadding,
  } = props;

  const onSelectOptionsHandler = (option: SortOptionT) => {
    if (onSelectOption) {
      onSelectOption(option);
    }
  };

  let sortOptions = [
    { label: "Сначала новые", value: 10 },
    { label: "Сначала старые", value: 20 },
  ];

  if (options) {
    sortOptions = options;
  }

  return (
    <div
      className={`table-top-panel ${withoutPadding ? "without_padding" : ""}`}
    >
      <p className="font-semibold">{text}</p>
      <div className="table-top-panel__widgets">
        <div
          className={`search-panel ${withoutPadding ? "without_margin" : ""} ${
            hideSearchPanel ? "hidden" : ""
          }`}
        >
          <input
            type="text"
            name="search"
            id="search"
            placeholder="Поиск"
            className="search-field"
          />
          <img
            src="/img/static/search-icon.png"
            alt=""
            className="search-icon"
            onClick={() => {
              const searchingValue = document.querySelector(
                "#search"
              ) as HTMLInputElement;
              return onSearch ? onSearch(searchingValue?.value || "") : null;
            }}
          />
        </div>
        <Select
          name="sort-option"
          id="sort-option-select"
          className={hideSelectPanel ? "hidden" : ""}
          defaultValue={{ label: "Сортировка", value: 0 }}
          menuPortalTarget={document.body}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: "#eaeaea",
              primary: "#00B856",
            },
          })}
          options={sortOptions}
          onChange={
            onSelectOptionsHandler as (option: SortOptionT | null) => void
          }
        />
      </div>
    </div>
  );
};

export const TableSearchProcedure = (props: TableSearchProcedurePropsT) => {
  const {
    text,
    onSearch,
    hideSearchPanel = "hidden",
    withoutPadding = true,
  } = props;

  return (
    <div
      className={`table-top-panel ${withoutPadding ? "without_padding" : ""}`}
    >
      <p className="font-semibold">{text}</p>
      <div className="table-top-panel__widgets">
        <div
          className={`search-panel ${withoutPadding ? "without_margin" : ""} ${
            hideSearchPanel ? "hidden" : ""
          }`}
        >
          <input
            type="text"
            name="search"
            id="search"
            placeholder="Поиск"
            className="search-field"
          />
          <img
            src="/img/static/search-icon.png"
            alt=""
            className="search-icon"
            onClick={() => {
              const searchingValue = document.querySelector(
                "#search"
              ) as HTMLInputElement;
              return onSearch ? onSearch(searchingValue?.value || "") : null;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export const TabItems: React.FC<TabItemsPropsT> = ({
  items,
  warning,
  warningLoading,
}) => {
  const { pathname } = useLocation();
  let btn;
  const tabs = items.map((item, idx) => {
    const regExp = new RegExp(`${item.path}${item.exact ? "$" : ""}`, "i");
    const isActive =
      regExp.test(pathname) ||
      (pathname.includes("procedure-control") &&
        item.path.includes("procedure-control"));

    if (isActive) btn = item.btn;

    return (
      <Link
        to={item.path}
        key={idx}
        className={`tab-item${isActive ? " active" : ""}`}
      >
        <div className={styles.tab_warning}>
          {(!warning?.isBriefingFill || !warning?.isTrainingFill) &&
            !warningLoading &&
            item.path.includes("procedure-control") && <WarnSVG />}
          {item.label}
        </div>
      </Link>
    );
  });

  return (
    <div className="tab-items">
      {tabs}
      {btn}
    </div>
  );
};

// GREEN BUTTON WITH PAGE TITLE FOR CREATING NEW RESOURCE

export const ColorfulButton: React.FC<ColorfulActionButtonPropsT> = (props) => {
  const {
    link,
    text,
    type,
    plusIcon = true,
    customIcon,
    className,
    disabled,
    onClick,
  } = props;

  let content = plusIcon ? (
    <svg
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  ) : null;

  content = customIcon || content;

  if (!link) {
    return (
      <button
        className={clsx("colorful_action_btn", className, {
          colorful_action_btn_noText: !text,
        })}
        onClick={(e) => (onClick ? onClick(e) : null)}
        type={type || "submit"}
        disabled={disabled || false}
      >
        {text && text}
        {content}
      </button>
    );
  }

  return (
    <Link
      to={link}
      className={clsx("colorful_action_btn", className, {
        colorful_action_btn_noText: !text,
      })}
      onClick={(e) => (onClick ? onClick(e) : null)}
    >
      {text && text}
      {content}
    </Link>
  );
};
export const selectTheme = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#eaeaea",
    primary: "#00B856",
  },
});

export const selectColourStyles = (
  containerStyles: any = {},
  { isError = false }: any = {}
): StylesConfig<any, any> => ({
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  container: (base) => ({
    ...base,
    backgroundColor: "#f5f6fa",
    marginTop: "15px",
    minHeight: "55px",
    maxHeight: "max-content",
    borderRadius: "5px",
    ...containerStyles,
    minWidth: "100px",
    ...(isError ? { border: "1px solid red" } : {}),
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#f5f6fa",
    minHeight: "55px",
    height: "100%",
    maxHeight: "165px",
    border: "none",
    overflowY: "auto",
  }),
  multiValue: (base) => ({
    ...base,
    fontSize: "18px",
    backgroundColor: "#eeeeee",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  input: (base) => ({
    ...base,
    width: "100%",
    height: "100%",
  }),
});
export const selectColourStylesBoxes = (
  containerStyles: any = {}
): StylesConfig<any, any> => ({
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  container: (base) => ({
    ...base,
    backgroundColor: "#f5f6fa",
    marginTop: "15px",
    minHeight: "55px",
    maxHeight: "max-content",
    borderRadius: "5px",
    ...containerStyles,
    minWidth: "100px",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#f5f6fa",
    minHeight: "55px",
    height: "100%",
    maxHeight: "165px",
    border: "none",
    overflowY: "auto",
  }),
  multiValue: (base) => ({
    ...base,
    fontSize: "18px",
    backgroundColor: "#eeeeee",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  input: (base) => ({
    ...base,
    width: "100%",
    height: "100%",
  }),
});

export const selectColourStyles2 = (
  containerStyles: any = {}
): StylesConfig<any, any> => ({
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  container: (base) => ({
    ...base,
    backgroundColor: "#f5f6fa",
    height: "40px",
    maxWidth: "190px",
    maxHeight: "max-content",
    borderRadius: "20px",
    ...containerStyles,
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#f5f6fa",
    height: "36px",
    border: "none",
    ...containerStyles,
  }),
  multiValue: (base) => ({
    ...base,
    fontSize: "18px",
    backgroundColor: "#eeeeee",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  option: (base, { isDisabled }) => ({
    ...base,
    color: "#373737",
    ...(isDisabled && { backgroundColor: "#eeeeee", opacity: 0.3 }),
  }),
});
export const selectColourStylesTarrifChangeButton = (
  controlStyles: any = {}
): StylesConfig<any, any> => ({
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  container: (base) => ({
    ...base,
    backgroundColor: "transparent",
    height: "36px",
    maxHeight: "max-content",
    cursor: "pointer",
    whiteSpace: "nowrap",
    minWidth: "165px",
    width: "max-content",
  }),
  control: (styles) => ({
    ...styles,
    height: "36px",
    color: "#fff",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    ...controlStyles,
  }),
  input: (styles) => ({ ...styles, color: "#fff" }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#fff",
  }),
  valueContainer: (base) => ({
    ...base,
    color: "#fff",
    padding: "0 12px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#fff !important",
    transform: "scale(1.2)",
  }),
  option: (base) => ({
    ...base,
    color: "#373737",
  }),
  loadingIndicator: (base) => ({
    ...base,
    color: "#fff !important",
  }),
});
export const selectColourStylesSigning = (
  containerStyles: any = {}
): StylesConfig<any, any> => ({
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  container: (base) => ({
    ...base,
    backgroundColor: "#f5f6fa",
    marginTop: "15px",
    minHeight: "55px",
    maxHeight: "max-content",
    borderRadius: "20px",
    ...containerStyles,
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#f5f6fa",
    minHeight: "55px",
    height: "100%",
    maxHeight: "165px",
    border: "none",
    overflowY: "scroll",
  }),
  multiValue: (base) => ({
    ...base,
    fontSize: "18px",
    backgroundColor: "#eeeeee",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? "red"
        : isSelected
          ? "#00B856"
          : isFocused
            ? "#eeeeee"
            : undefined,
      color: isDisabled ? "#ccc" : isSelected ? "white" : undefined,
    };
  },
});
export const Title: React.FC<TitlePropsT> = ({ text }) => {
  return (
    <h1>
      {text.map((e, i) => (
        <div key={`link_title_${i}`} className={clsx(style.title_item)}>
          <Link
            to={e.href ? e.href : "/"}
            className={e.disabled ? clsx(style.title_item_disabled) : undefined}
          >
            {e.title}
          </Link>
          {i < text.length - 1 && (
            <img src="/img/static/arrow_right.svg" alt="arrow_right" />
          )}
        </div>
      ))}
    </h1>
  );
};

export type DocumentViewButtonPropsT = {
  fileName: string;
  filePath: string;
  withoutIcon?: boolean;
  modal?: any;
  fileKey?: string;
};

export const DocumentViewButton = React.forwardRef(
  (
    { fileName, filePath, withoutIcon = false, modal, fileKey }: DocumentViewButtonPropsT,
    ref: React.LegacyRef<HTMLButtonElement> | undefined
  ) => {
    const fileUrl = `${process.env.API_URL}/${filePath}`;

    const viewBtnForPDF = (
      <EmbedPDF>
        <a href={fileUrl}>
          {withoutIcon ? (
            <>{fileName}</>
          ) : (
            <WrapperSVG color={"blue-dark"} margin>
              <EyeSVG size={24} />
            </WrapperSVG>
          )}
        </a>
      </EmbedPDF>
    );

    const viewBtnForImage = (
      <PhotoProvider>
        <PhotoView src={fileUrl}>
          <button>
            {withoutIcon ? (
              <>{fileName}</>
            ) : (
              <WrapperSVG color={"blue-dark"} margin>
                <EyeSVG size={24} />
              </WrapperSVG>
            )}
          </button>
        </PhotoView>
      </PhotoProvider>
    );
    const viewBtnForDocx = (
      <button
        onClick={() => {
          modal.open("DocumentEditorModal", {
            btnText: "Сохранить",
            modalData: {
              file: {
                type: filePath.split(".")[1].toLocaleLowerCase(),
                name: fileName,
                path: filePath,
                key: fileKey,
              },
            },
          });
        }}
      >
      {withoutIcon ? (
        <>{fileName}</>
      ) : (
        <WrapperSVG color="orange" margin>
          <NotePencilIcon size={24} alt="Редактировать" />
        </WrapperSVG>
      )}
      </button>
    );
    const extension = fileName.split(".").pop();

    switch (extension) {
      case "jpeg":
      case "jpg":
      case "png":
        return viewBtnForImage;
      case "pdf":
        return viewBtnForPDF;
      case "docx":
      case "doc":
        return viewBtnForDocx;
      default:
        return null;
    }
  }
);
